import * as AbsintheSocket from '@absinthe/socket'
import { Socket as PhoenixSocket } from 'phoenix'
import { createAbsintheSocketLink } from 'pluralsh-absinthe-socket-apollo-link'

import config from 'constants/config'

export default createAbsintheSocketLink(
  AbsintheSocket.create(new PhoenixSocket(`${config.app}${config.ws}`))
)
